'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_STATE = undefined;

var _immutable = require('immutable');

var _getActionName = require('../../utils/get-action-name');

var _getActionName2 = _interopRequireDefault(_getActionName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = exports.INITIAL_STATE = new _immutable.Map();

var isPending = function isPending(actionType) {
  return actionType.toString().includes('PENDING');
};

var isResponse = function isResponse(actionType) {
  return actionType.toString().includes('FULFILLED') || actionType.toString().includes('REJECTED');
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  var actionName = (0, _getActionName2.default)(action.type);
  var actionCount = actionName + '_COUNT';

  var count = state.get(actionCount) || 0;

  if (isPending(action.type)) {
    return state.set(actionCount, count + 1).set(actionName, count + 1 > 0);
  }

  if (isResponse(action.type)) {
    return state.set(actionCount, count - 1).set(actionName, count - 1 > 0);
  }
  return state;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/boilerplate/reducers/loading/index.js
// module id = 573
// module chunks = 0